module.exports = __webpack_public_path__ + "static/media/保腎護心網layout物件_07.36263a2e.png";